<fgb-mobile-page-header [pageTitle]="'games.banner.title'" [backButtonLink]="'/'" />
<fgb-banner class="d-lg-block d-none" [title]="'games.banner.title' | translate" />

<div class="container mt-lg-4 mt-0 mobile-container">
  <div class="mt-4 mt-lg-0">
    <div class="game-container-sections">
      <div class="w-100 game-card">
        <div class="img-wrapper">
          <img [src]="'games/trivia-widget.jpeg' | contentAssetImage" />
        </div>
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.trivia' | translate }}</h5>
            <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/trivia'">
            <div class="btn btn-secondary">{{ 'games.page.trivia.play' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="w-100 game-card">
        <div class="img-wrapper">
          <img [src]="'games/polls-widget.jpeg' | contentAssetImage" />
        </div>
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.polls' | translate }}</h5>
            <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/polls'">
            <div class="btn btn-secondary">{{ 'games.page.polls.play' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="w-100 game-card">
        <div class="img-wrapper">
          <img [src]="'games/predictor-widget.jpeg' | contentAssetImage" />
        </div>
        <div class="card">
          <div class="">
            <h5>{{ 'games.page.predictor' | translate }}</h5>
            <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/predictor'">
            <div class="btn btn-secondary">{{ 'games.page.predictor.play' | translate }}</div>
          </div>
        </div>
      </div>

      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.fantasy'">
        <div class="w-100 game-card">
          <div class="img-wrapper">
            <img [src]="'games/fantasy-widget.jpeg' | contentAssetImage" />
          </div>
          <div class="card">
            <div class="">
              <h5>{{ 'games.page.pap' | translate }}</h5>
              <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
            </div>
            <div [routerLink]="'/games/pickaplayer'">
              <div class="btn btn-secondary">{{ 'games.page.pap.play' | translate }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
